import { useState, useEffect, useContext } from 'react';
import axios from 'axios'
import UserContext from '../../../../context/UserContext';
import { getHistoricalDataUrl } from '../../../history/api/HistoricalDataApi';

// const MINIMAL_INTERVAL = 10 * 1000
const REGULAR_INTERVAL = 40 * 1000
const EXTENDED_INTERVAL = 120 * 1000
const DEFAULT_TOTAL_TASKS = 0
const SUPPORTED_CATEGORIES = ["user", "all_user", "admin"]


export const DEFAULT_LIMIT_INCREMENT = 50000
export const HISTORY_SEARCH_TYPES = {
    "Log Entry": "search_logs",
    "CSV Uploaded": "search_csv", 
    "Parameters": "search_params",
}

export function parseCSV(obj) {
    if (typeof obj === 'string' || obj instanceof String) {
        try {
            return JSON.parse(obj);
        } catch (e) {
        }
    }
    // If obj is not a string, return it as it is
    return obj;
}

export function useGetSingleTask(task_id) {
    const [urlResponse, setUrlResponse] = useState([])
    const historyAPI = getHistoricalDataUrl()
    const [isLoading, setIsloading] = useState(true)

    useEffect(() => {
        let taskUrl = (
            "https://" + historyAPI + "/api/1/triage/single_task/" + task_id
        )
        const fetchAPI = async () => {
            setIsloading(true)
            //setUrlResponse([])
            axios.get(taskUrl).then(
                response => {
                    setIsloading(false)
                    setUrlResponse(response.data)
                }
            ).catch(
                error => { 
                    setIsloading(false)
                    console.log(error)
                    setUrlResponse([]) 
                }
            )
        }

        fetchAPI()
        const interval = setInterval(() => {
            fetchAPI()
        }, REGULAR_INTERVAL)
        return () => {
            setIsloading(false)
            setUrlResponse([])
            clearInterval(interval)
        }
    }, [historyAPI, task_id])
    return { urlResponse: urlResponse, isLoading: isLoading }
}


export function useGetTasksByPerson(envSelected, offset, limit) {
    const token = useContext(UserContext)
    const [personId, setPersonId] = useState(0)
    const [urlResponse, setUrlResponse] = useState([])
    const historyAPI = getHistoricalDataUrl()
    const [isLoading, setIsloading] = useState(true)

    useEffect(() => {
        if (token && token.personId) {
            setPersonId(token.personId)
        }
    }, [token])

    useEffect(() => {
        if (personId !== 0) {
            let taskUrl = (
                "https://" + historyAPI + "/api/1/triage/task/" + envSelected + "?person_id=" + personId +
                "&offset=" + offset + "&limit=" + limit
            )
            setIsloading(true)
            const fetchAPI = async () => {
                //setUrlResponse([])
                axios.get(taskUrl).then(
                    response => {
                        setIsloading(false)
                        setUrlResponse(response.data)
                    }
                ).catch(
                    error => { 
                        setIsloading(false)
                        console.log(error)
                        setUrlResponse([]) 
                    }
                )
            }

            fetchAPI()
            const interval = setInterval(() => {
                fetchAPI()
            }, REGULAR_INTERVAL)
            return () => {
                setUrlResponse([])
                setIsloading(false)
                clearInterval(interval)
            }
        }
    }, [personId, historyAPI, envSelected, offset, limit])
    return { urlResponse: urlResponse, isLoading: isLoading }
}


export function useGetTotalTasks(envSelected, category) {
    const token = useContext(UserContext)
    const [personId, setPersonId] = useState(0)
    const [urlResponse, setUrlResponse] = useState(DEFAULT_TOTAL_TASKS)
    const historyAPI = getHistoricalDataUrl()
    const [isLoading, setIsloading] = useState(true)

    useEffect(() => {
        if (token && token.personId) {
            setPersonId(token.personId)
        }
    }, [token])

    useEffect(() => {
        if (SUPPORTED_CATEGORIES.includes(category) && personId !== 0) {
            let taskUrl = (
                "https://" + historyAPI + "/api/1/triage/total_tasks/" + envSelected + "?person_id=" + personId + "&category=" + category
            )

            const fetchAPI = async () => {
                //setUrlResponse(DEFAULT_TOTAL_TASKS)
                axios.get(taskUrl).then(
                    response => {
                        setIsloading(false)
                        if(response && response.data && response.data.length > 0) {
                            let total_tasks = parseInt(response.data[0].total_tasks)
                            setUrlResponse(Math.max(total_tasks, DEFAULT_TOTAL_TASKS))
                        }
                        
                    }
                ).catch(
                    error => { setUrlResponse(DEFAULT_TOTAL_TASKS) }
                )
            }

            fetchAPI()
            const interval = setInterval(() => {
                fetchAPI()
            }, EXTENDED_INTERVAL)
            return () => {
                setUrlResponse(DEFAULT_TOTAL_TASKS)
                clearInterval(interval)
            }
        }

    }, [personId, historyAPI, envSelected, category])
    return { urlResponse: urlResponse, isLoading: isLoading }
}



export function useGetAllUserTasks(envSelected, offset, limit) {
    const [urlResponse, setUrlResponse] = useState([])
    const [isLoading, setIsloading] = useState(true)
    const historyAPI = getHistoricalDataUrl()

    useEffect(() => {
        setIsloading(true)
        let taskUrl = (
            "https://" + historyAPI + "/api/1/triage/all_user_tasks/" + envSelected +
            "?offset=" + offset + "&limit=" + limit
        )
        const fetchAPI = async () => {
            //setUrlResponse([])
            axios.get(taskUrl).then(
                response => {
                    setIsloading(false)
                    setUrlResponse(response.data)
                }
            ).catch(
                error => { 
                    setIsloading(false)
                    setUrlResponse([]) 
                }
            )
        }

        fetchAPI()
        const interval = setInterval(() => {
            fetchAPI()
        }, REGULAR_INTERVAL)
        return () => {
            setUrlResponse([])
            clearInterval(interval)
        }
    }, [historyAPI, envSelected, offset, limit])
    return { urlResponse: urlResponse, isLoading: isLoading }
}

export function useGetServiceAccountTasks(envSelected, offset, limit) {
    const [urlResponse, setUrlResponse] = useState([])
    const historyAPI = getHistoricalDataUrl()
    const [isLoading, setIsloading] = useState(true)

    useEffect(() => {
        setIsloading(true)
        let taskUrl = (
            "https://" + historyAPI + "/api/1/triage/all_admin_tasks/" + envSelected +
            "?offset=" + offset + "&limit=" + limit
        )
        const fetchAPI = async () => {
            //setUrlResponse([])
            axios.get(taskUrl).then(
                response => {
                    setIsloading(false)
                    setUrlResponse(response.data)
                }
            ).catch(
                error => { 
                    setIsloading(false)
                    setUrlResponse([]) 
                }
            )
        }

        fetchAPI()
        const interval = setInterval(() => {
            fetchAPI()
        }, REGULAR_INTERVAL)
        return () => {
            setUrlResponse([])
            setIsloading(false)
            clearInterval(interval)
        }
    }, [historyAPI, envSelected, offset, limit])
    return { urlResponse: urlResponse, isLoading: isLoading }
}


export function useGetTaskLogging(task_id) {
    const [urlResponse, setUrlResponse] = useState([])
    const historyAPI = getHistoricalDataUrl()
    const [isLoading, setIsloading] = useState(true)

    useEffect(() => {
        let taskUrl = (
            "https://" + historyAPI + "/api/1/triage/logs?task_id=" + task_id
        )
        setIsloading(true)
        const fetchAPI = async () => {
            //setUrlResponse([])
            axios.get(taskUrl).then(
                response => {
                    setIsloading(false)
                    setUrlResponse(response.data)
                }
            ).catch(
                error => { 
                    setIsloading(false)
                    setUrlResponse([]) 
                }
            )
        }

        fetchAPI()
        const interval = setInterval(() => {
            fetchAPI()
        }, EXTENDED_INTERVAL)
        return () => {
            setUrlResponse([])
            setIsloading(false)
            clearInterval(interval)
        }
    }, [historyAPI, task_id])
    return { urlResponse: urlResponse, isLoading: isLoading }
}


export function useGetTaskResults(task_id) {
    const [urlResponse, setUrlResponse] = useState([])
    const historyAPI = getHistoricalDataUrl()
    const [isLoading, setIsloading] = useState(true)

    useEffect(() => {
        let taskUrl = (
            "https://" + historyAPI + "/api/1/triage/results?task_id=" + task_id
        )
        const fetchAPI = async () => {
            //setUrlResponse([])
            axios.get(taskUrl).then(
                response => {
                    setIsloading(false)
                    setUrlResponse(response.data)
                }
            ).catch(
                error => { setUrlResponse([]) }
            )
        }

        fetchAPI()
        const interval = setInterval(() => {
            fetchAPI()
        }, EXTENDED_INTERVAL)
        return () => {
            setUrlResponse([])
            clearInterval(interval)
        }
    }, [historyAPI, task_id])
    return { urlResponse: urlResponse, isLoading: isLoading }
}

export function useGetSearchByType(envSelected, searchType, keyword) {
    const [urlResponse, setUrlResponse] = useState([])
    const historyAPI = getHistoricalDataUrl()
    const [isLoading, setIsloading] = useState(false)
    const [searchMethod, setSearchMethod] = useState("search_logs")

    useEffect(() => {
        if(keyword.length > 0) {
            setIsloading(true)
        }
    }, [keyword])

    useEffect(() => {
        setSearchMethod(HISTORY_SEARCH_TYPES[searchType])
    }, [searchType])

    useEffect(() => {
        if (keyword.length > 0)
        {
            setIsloading(true)
            let taskUrl = (
                "https://" + historyAPI + "/api/1/triage/" + searchMethod + "/" + envSelected + "?keyword=" + keyword
            )
            const fetchAPI = async () => {
                //setUrlResponse([])
                axios.get(taskUrl).then(
                    response => {
                        setIsloading(false)
                        setUrlResponse(response.data)
                    }
                ).catch(
                    error => { 
                        setUrlResponse([])
                        setIsloading(false)
                        console.log(error)
                     }
                )
            }
            fetchAPI()

            const interval = setInterval(() => {
                fetchAPI()
            }, REGULAR_INTERVAL)    
            return () => {
                setUrlResponse([])
                clearInterval(interval)
            }
        }
        
    }, [historyAPI, envSelected, searchMethod, keyword])
    return { urlResponse: urlResponse, isLoading: isLoading }
}